const Bacon = require("baconjs");
const R = require("ramda");
const Globalize = require('globalize');

const locales = {
    'en':    require("bundle-loader?lazy&name=locale_en!../i18n/en"),
    'en-CA': require("bundle-loader?lazy&name=locale_en-CA!../i18n/en-CA"),
    'en-GB': require("bundle-loader?lazy&name=locale_en-GB!../i18n/en-GB"),
    'en-IE': require("bundle-loader?lazy&name=locale_en-IE!../i18n/en-IE"),
    'en-MT': require("bundle-loader?lazy&name=locale_en-MT!../i18n/en-MT"),
    'en-NZ': require("bundle-loader?lazy&name=locale_en-NZ!../i18n/en-NZ"),
    'en-AU': require("bundle-loader?lazy&name=locale_en-AU!../i18n/en-AU"),
    'en-KW': require("bundle-loader?lazy&name=locale_en-KW!../i18n/en-KW"),
    'ar-KW': require("bundle-loader?lazy&name=locale_ar-KW!../i18n/ar-KW"),
    'nl':    require("bundle-loader?lazy&name=locale_nl!../i18n/nl"),
    'nl-BE': require("bundle-loader?lazy&name=locale_nl-BE!../i18n/nl-BE"),
    'fr-BE': require("bundle-loader?lazy&name=locale_fr-BE!../i18n/fr-BE"),
    'ja':    require("bundle-loader?lazy&name=locale_ja!../i18n/ja")
};

const setupLocale = R.curry((locale, sink, { config, messages, currency }) => {
    Globalize.load(config);
    Globalize.loadMessages(R.assoc(locale, messages, {}));
    Globalize.locale(locale);
    sink({
        locale: locale,
        currency: currency,
        formatCurrency: Globalize.currencyFormatter(currency)
    });
});

const notifyError = (title,  message) =>
      window.Bugsnag && window.Bugsnag.notify && window.Bugsnag.notify(title,  message);

export const loadLocale = (locale) => {
    if (!locales[locale]) {
        notifyError("Missing locale", `Requested ${locale} locale is not defined!`);
        locale = 'en';
    }

    const localeLoader = locales[locale];
    return Bacon.fromCallback((sink) => {
        localeLoader(setupLocale(locale, sink));
    });
}
